/* global moment */

import { Picker } from '../controls/picker.mjs';
import { create, registerCustomElement } from '../utils.mjs';
import { SelectInput } from './select.mjs';
import './list.scss';

export class ListInput extends SelectInput {
	/**
	 * Builds the input dom.
	 *
	 * @param instructions {object} Collection of directives.
	 * @param value {any} Initial value.
	 * @param metadata {object} Metadata.
	 */

	async _build(instructions, value, metadata) {
		instructions.mappable = false;

		if (!metadata.build) {
			metadata.build = {};
		}

		metadata.build.picker = create('imt-picker');
		metadata.build.picker.list = true;
		metadata.build.pickerPath = () => this.form.meta.commonRpcParameters;
		metadata.build.picker.register(Picker.COMPONENTS.OPTION_RENDERER, (option, item, options) => {
			if (options) {
				options.classList.add('list-group', 'dmo-flex', 'dmo-gap-[6px]', 'dmo-max-h-[200px]', 'dmo-overflow-auto');
			}

			option.classList.add('list-group-item', 'list-control-group-item', 'list-control-selected');
			option.textContent = '';

			const valueField = metadata.build.picker.getAttribute('value-field') || instructions.options.value || 'value';
			const labelField = metadata.build.picker.getAttribute('label-field') || instructions.options.label || 'label';
			const descriptionField =
				metadata.build.picker.getAttribute('description-field') || item.description || instructions.options.description;

			const formattedDate = moment(item.date).format('L LT');
			let desc = formattedDate;

			if (descriptionField) {
				const date = create('div.small.list-control-muted-text.text-truncate');

				option.append(date);
				date.textContent = formattedDate;

				desc = descriptionField;
			}

			const title = create('div.list-group-title.text-truncate');

			title.textContent = instructions.options.title || item[labelField] || item[valueField];
			option.append(title);

			if (!descriptionField) {
				const subtitle = create('small.list-control-muted-text.text-truncate');

				subtitle.textContent = desc;
				option.append(subtitle);
			}
		});

		await super._build(instructions, value, metadata);
	}
}

registerCustomElement('imt-input-list', ListInput);
